// extracted by mini-css-extract-plugin
module.exports = {"author":"Author-module--author--1wW-M","author__logo":"Author-module--author__logo--3Fga5"};